/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_PolicyInputs */

const en_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const th_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นโยบายความเป็นส่วนตัว`)
};

const ja_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

const fr_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const es_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const ru_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

const zh_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const vi_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chính sách quyền riêng tư`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const privacy_policy = /** @type {((inputs?: Privacy_PolicyInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_PolicyInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_privacy_policy(inputs)
	if (locale === "ja") return ja_privacy_policy(inputs)
	if (locale === "fr") return fr_privacy_policy(inputs)
	if (locale === "es") return es_privacy_policy(inputs)
	if (locale === "ru") return ru_privacy_policy(inputs)
	if (locale === "zh") return zh_privacy_policy(inputs)
	if (locale === "vi") return vi_privacy_policy(inputs)
	return en_privacy_policy(inputs)
});